var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationsInfo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#0944B3",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.538 17.423V11.5a.846.846 0 0 0-.846-.846H10m1.27-4.231a.423.423 0 1 1 0 .846.423.423 0 0 1 0-.846M10 17.425h5.077",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export { SvgNotificationsInfo as ReactComponent };
export default __webpack_public_path__ + "assets/images/notifications-info.svg";